export interface ShiftSlot{
    startIndex : number;
    endIndex : number;
    actualStartIndex ?:number;
    actualEndIndex ?:number;
}

export class FNTimeData {
    timeString = "";
    index = -1;
    minute = -1;
  }
  